<template>
  <h2>中医体质分析</h2>
  <van-notice-bar
    wrapable
    :scrollable="false"
    color="#1989fa"
    background="#ecf9ff"
    left-icon="volume-o"
  >
    <p class="textIndentation">
      本结果核心是通过大数据完成建模并分析，医学部分充分依据中医体质相关指南！
    </p>
  </van-notice-bar>

  <van-notice-bar
    wrapable
    :scrollable="false"
    color="#1989fa"
    background="#ecf9ff"
  >
    <p class="text2Indentation">
      特别说明：此分析并非诊疗服务。受限于数据的准确性和个人的体感，存在一定的偏差。我们建议您依据此项评估，
      前往中医门诊进一步确认，并提前做好健康调理。（如果您签署【早知心健康年包服务】，我们会将这项结果自动同步给医生！）
    </p>
  </van-notice-bar>
  <van-divider
    :style="{ color: '#EA6853', borderColor: '#EA6853' }"
    content-position="center"
    dashed
    >个人信息</van-divider
  >
  <van-cell-group inset>
    <van-field
      left-icon="wap-home"
      v-model="userInfo.hospitalName"
      label="体检机构"
      readonl
    >
    </van-field>
    <van-field
      left-icon="user-o"
      v-model="userInfo.realName"
      label="真实姓名"
      readonly
    />
    <van-field
      left-icon="phone-o"
      v-model="userInfo.phone"
      label="预留手机号"
      readonly
    />
  </van-cell-group>
  <van-divider
    :style="{ color: '#EA6853', borderColor: '#EA6853' }"
    content-position="center"
    dashed
    >分析结果</van-divider
  >
  <p>基于您的当前情况，我们对您的体质分析为：</p>
  <div class="about" id="level"></div>
  <van-notice-bar wrapable :scrollable="false" left-icon="info-o">
    <p class="textIndentation">
      体质是人类生命活动的一种重要表现形式，在先天禀赋和后天获得的基础上形成的形态结构、生理功能和心理状态的综合。中医把人的体质分为9种，每一种体质都有不同的应对方式及诱发因素。标准如下:
    </p>
  </van-notice-bar>
  <br />
  <van-cell-group inset>
    <van-field
      label="阳虚"
      model-value="阳气不足，以畏寒怕冷、手足不温等虚寒表现。"
      rows="1"
      autosize
      type="textarea"
      readonly
    />
    <van-field
      label="阴虚"
      model-value="阴液亏少，以口燥咽干、手足心热等虚热表现。"
      rows="1"
      autosize
      type="textarea"
      readonly
    />
    <van-field
      label="气虚"
      model-value="元气不足，以疲乏、气短、自汗等气虚表现为主要特征。"
      rows="1"
      autosize
      type="textarea"
      readonly
    />
    <van-field
      label="痰湿"
      model-value="痰湿凝聚，以形体肥胖、腹部肥满、口黏苔腻等痰湿表现。"
      rows="1"
      autosize
      type="textarea"
      readonly
    />
    <van-field
      label="湿热"
      model-value="湿热内蕴，以面垢油光、口苦、苔黄腻等湿热表现。"
      rows="1"
      autosize
      type="textarea"
      readonly
    />
    <van-field
      label="血瘀"
      model-value="血行不畅，以肤色晦暗、舌质紫暗等血瘀表现为主要特征。"
      rows="1"
      autosize
      type="textarea"
      readonly
    />
    <van-field
      label="气郁"
      model-value="气机郁滞，以神情抑郁、忧虑脆弱等气郁表现。"
      rows="1"
      autosize
      type="textarea"
      readonly
    />
    <van-field
      label="过敏"
      model-value="先天失常，以生理缺陷、过敏反应等为主要特征。"
      rows="1"
      autosize
      type="textarea"
      readonly
    />
    <van-field
      label="平和"
      model-value="阴阳气血调和，以形态适中、面色红润、精力充沛等为主要特征"
      rows="1"
      autosize
      type="textarea"
      readonly
    />
  </van-cell-group>
</template>

<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import * as echarts from "echarts";
import { getUserInfo } from "../../api/userinfo";
import { postUserChMedRisk } from "../../api/queInfo";
import { useRouter } from "vue-router";
import { postUserLog } from "../../api/userlog";
export default {
  setup() {
    const router = useRouter();
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    const state = reactive({
      userInfo: {
        hospitalName: "",
        area: "",
        realName: "",
        phone: "",
        age: "",
        gender: "",
      },
    });
    const userChMedRiskVoList = reactive({
      userChMedRiskVo: {
        chMedArr: "",
      },
    });
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      getUserInfo().then((res1) => {
        state.userInfo = res1.data.data;
        console.log(res1.data.data);
      });
      postUserChMedRisk().then((res) => {
        userChMedRiskVoList.userChMedRiskVo = res.data.data;
        console.log(res.data.data);
        levelInit();
      });
    });
    function levelInit() {
      var myChart = echarts.init(document.getElementById("level"));
      console.log(userChMedRiskVoList.userChMedRiskVo.chMedArr);
      myChart.setOption({
        legend: {
          data: ["您的体质"],
        },
        radar: {
          // shape: 'circle',
          indicator: [
            { name: "阳虚", max: 154 },
            { name: "阴虚", max: 163 },
            { name: "气虚", max: 116 },
            { name: "痰湿", max: 147 },
            { name: "湿热", max: 118 },
            { name: "血瘀", max: 154 },
            { name: "气郁", max: 100 },
            { name: "过敏", max: 100 },
            { name: "平和", max: 100 },
          ],
        },
        series: [
          {
            name: "您的体质",
            type: "radar",
            data: [
              {
                //        value: [75, 50, 20, 35, 47, 18, 99, 87, 21],
                value: userChMedRiskVoList.userChMedRiskVo.chMedArr,
                name: "Allocated Budget",
              },
            ],
          },
        ],
      });
    }

    return {
      userChMedRiskVoList,
      ref,
      ...toRefs(state),
    };
  },
};
</script>
<style lang="less" scoped>
#level {
  height: 400px;
  width: 100%;
}

#risk {
  height: 400px;
  width: 100%;
}

.van-cell {
  border-radius: 30rpx;
  margin: 40rpx 0 0 0;
}

/* 去除单元格cell下边框 */
.van-cell:after {
  border-bottom: none !important;
  border-bottom-style: none !important;
}

/* 单元格标题title */
.van-cell .van-cell__title {
  color: #7186e1;
}

/* 标题下方label */
.van-cell .van-cell__label {
  color: #000;
  font-weight: 500;
}

.textIndentation {
  font-size: 12px;
  text-align: left;
  margin-top: 10px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 500px;
  height: 400px;
}
.textIndentation {
  text-align: left;
  font-weight: bold;
  font-size: 14px;
}
.text2Indentation {
  text-align: left;
  font-size: 12px;
}
</style>
